const ReducerConstants = {
  authLogin: 'auth/LOGIN',
  authLogout: 'auth/LOGOUT'
};


export default ReducerConstants;
